<template>
    <div class="subPage">
        <!-- 头部 -->
        <Header :property="property" :profit="profit"/>
        <!-- 表格数据 -->
        <TableDetail
            :incomeRetail="incomeRetail"
            :totalIncomeRetail="totalIncomeRetail"
            :incomeTeam="incomeTeam"
            :totalIncomeTeam="totalIncomeTeam"
        />
        <!-- 占位 -->
        <Empty />
      <go-back-home/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from '../userProfitElement/Header';
import TableDetail from '../userProfitElement/TableDetail';
import Empty from '../comm/Empty';

export default {
  name: 'Profit',
  meta:{page:true},
  computed: {
        ...mapGetters('user', {
            property: 'getProperty',
            profit: 'getProfit',
            incomeRetail: 'getIncomeRetail',
            totalIncomeRetail: 'getTotalIncomeRetail',
            incomeTeam: 'getIncomeTeam',
            totalIncomeTeam: 'getTotalIncomeTeam'
        })
  },
  components: {
      Header,
      TableDetail,
      Empty
  },
  created() {
      this.$store.dispatch('user/getUserProFit');
      this.$store.dispatch('user/getProfit');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/Profit.vue